import {find, createSelector, keyBy} from 'helpers';
import {timestamp} from 'store/common';
import {diary} from './diary';
import {dates} from './list';

const predefined = [
  { value: 5, key: 'happyOrSad', bad: 'Depressed', good: 'Happy' },
  { value: 5, key: 'focusedOrConfused', bad: 'Confused', good: 'Focused' },
  { value: 5, key: 'inspiredOrDiscouraged', bad: 'Discouraged', good: 'Motivated' },
  { value: 5, key: 'relaxedOrStressed', bad: 'Stressed', good: 'Relaxed' },
  { value: 5, key: 'energeticOrExhausted', bad: 'Exhausted', good: 'Energetic' },
  { value: 5, key: 'progressOrStuck', bad: 'Stuck', good: 'Making Progress' },
];

export const emotionsMeter = createSelector(
  state => state.diary.emotionsMeter,
  index => keyBy(index, 'date'),
);

export const mood = createSelector(
  [ diary, emotionsMeter ],
  ( diary, emotionsMeter ) => {
    if (diary && emotionsMeter[diary.date] &&  /My Mood/.test(diary.subject)) {
      return {
        emotionsMeterId: emotionsMeter[diary.date].id,
        emotions: predefined.map(emotion => ({
          ...emotion,
          value: emotionsMeter[diary.date][emotion.key],
        }))
      }
    }
  }
);

export const moodByDate = createSelector(
  [ dates, emotionsMeter, timestamp ],
  ( dates, emotionsMeter, timestamp ) => {
    const record = find(dates[timestamp], { subject: 'My Mood' });
    if (record) {
      return {
        diaryId: record.id,
        emotionsMeterId: emotionsMeter[timestamp].id,
        emotions: predefined.map(emotion => ({
          ...emotion,
          value: emotionsMeter[timestamp][emotion.key],
        }))
      }
    }
    return { emotions: predefined }
  }
);
